import styled from 'styled-components';

export default styled.div`
  .ant-input-suffix {
    z-index: 2;
  }
  .phone-number {
    padding-left: 55px;
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;
  }

  .phone-code {
    position: absolute;
    width: 44px;
    height: 36px;
    background: rgb(255, 255, 255);
    box-shadow: 0px 0px 0px 1px rgba(130, 136, 148, 0.16),
      0px 1px 1px -1px rgba(130, 136, 148, 0.48);
    border-radius: 4px;
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
    z-index: 2;
    margin: 5px;
    padding-left: 5px;
    padding-right: 2px;
  }
`;
